module.exports = __webpack_public_path__ + "media/src/images/course-cover-default-9a011c1a2230b18a92097cb95669b84e.jpg";